import React from 'react'

function WalletTabs() {
    return (<>
        <div className='d-flex gap-3 align-items-center flex-wrap '>
            <div className='wallet_tabs'>
                <div className='tab_innerwallet'>
                    <ul className="nav nav-pills wallet_nav" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className=" nav-link wallet_link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" style={{ color: "#1CAC19", fontSize: "12px" }}>Monthly</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link wallet_link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" style={{ color: "#1CAC19", fontSize: "12px" }}>Yearly</button>
                        </li>

                    </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">

                </div>
            </div>
            <div className='d-flex gap-2 align-items-center'>
                <p className='sicial_account'>Social Accounts</p>
                <div className='number_div'>05</div>
            </div>
        </div>





    </>

    )
}

export default WalletTabs